export type PersonalizationTokens = Partial<
	Record<'nombre' | 'porcentaje' | 'marca' | 'talla' | 'producto' | 'fecha', string>
>;

const TOKEN_PATTERN = /\{(\w+)\}/g;
const OPTIONAL_PATTERN = /\[([^\]]*)\]/g;
const LEADING_PUNCTUATION_PATTERN = /^[\s,.;:·-]+/;

const readToken = (tokens: PersonalizationTokens, key: string) =>
	tokens[key as keyof PersonalizationTokens]?.trim() || undefined;

const hasEveryToken = (text: string, tokens: PersonalizationTokens) =>
	Array.from(text.matchAll(TOKEN_PATTERN)).every(([, key]) => !!readToken(tokens, key));

export const fillPersonalization = (template: string | undefined, tokens: PersonalizationTokens) =>
	(template ?? '')
		.replace(OPTIONAL_PATTERN, (_, segment: string) =>
			hasEveryToken(segment, tokens) ? segment : ''
		)
		.replace(TOKEN_PATTERN, (_, key: string) => readToken(tokens, key) ?? '')
		.replace(/\s{2,}/g, ' ')
		.replace(LEADING_PUNCTUATION_PATTERN, '')
		.trim();
